import { deliveryKeys } from 'common/constants/settings';
import * as types from './types';

const initialState = {
  getInProcess: true,
  updateInProcess: false,
  data: {},
  errors: null,
  deliverActiveTab: deliveryKeys.reservation,
  [deliveryKeys.reservation]: true,
  [deliveryKeys.delivery]: false,
  [deliveryKeys.takeaway]: false,
  [deliveryKeys.reservation]: {
    opening_hours: [],
    opening_hour_exceptions: [],
    isFetched: false,
    errors: null,
  },
  [deliveryKeys.delivery]: {
    opening_hours: [],
    opening_hour_exceptions: [],
    isFetched: false,
    errors: null,
  },
  [deliveryKeys.takeaway]: {
    opening_hours: [],
    opening_hour_exceptions: [],
    isFetched: false,
    errors: null,
  },
};

const settingsReducer = (state = initialState, action) => {
  const { deliveryActiveTab } = action.payload || {};
  switch (action.type) {
    case types.SETTINGS_GET_REQUEST:
      return {
        ...state,
        getInProcess: true,
      };
    case types.SETTINGS_GET_SUCCESS:
      return {
        ...state,
        getInProcess: false,
        data: action.payload,
      };
    case types.SETTINGS_GET_FAILURE:
      return {
        ...state,
        getInProcess: false,
      };
    case types.SETTINGS_UPDATE_REQUEST:
      return {
        ...state,
        updateInProcess: true,
      };
    case types.SETTINGS_UPDATE_SUCCESS:
    case types.SETTINGS_UPDATE_FAILURE:
      return {
        ...state,
        updateInProcess: false,
        errors: action.payload,
      };

    case types.SETTINGS_SET_HOURS_ERRORS:
      const { errors } = action.payload;
      return {
        ...state,
        [deliveryActiveTab]: {
          ...state[deliveryActiveTab],
          errors,
        },
      };
    case types.SETTINGS_CHANGE_DELIVERY_DATA:
      const { day, data } = action.payload;
      const currentData = state[deliveryActiveTab].opening_hours;
      const newData = [...currentData].map((i) => {
        if (parseFloat(i.day_number) === parseFloat(day)) {
          return {
            ...i,
            ...data,
          };
        }

        return i;
      });
      return {
        ...state,
        [deliveryActiveTab]: {
          ...state[deliveryActiveTab],
          opening_hours: newData,
          errors: null,
        },
      };
    default:
      return state;
  }
};

export default settingsReducer;
